import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faSave, faCalendarAlt, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../../hooks/useFetch";
import Swal from "sweetalert2";

export default function Evento() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { get, post, put } = useFetch();
    const location = useLocation();

    const [state, setState] = useState({
        acao: location.state?.acao || (id === "criar" ? "Criar" : "Visualizar"),
        dados: { nome_evento: "", tipo_evento: "", data_inicio: "", data_fim: "", local_evento: "", descricao: "" }
    });

    useEffect(() => {
        if (id !== "criar") {
            get(`/eventodocumentado/${id}`).then(r => {
                if (r.ok) setState(s => ({ ...s, dados: r.result.data }));
            });
        }
    }, [id]);

    const salvar = async () => {
        const method = id === "criar" ? post : put;
        const url = id === "criar" ? '/eventodocumentado' : `/eventodocumentado/${id}`;
        const response = await method(url, state.dados);
        if (response.ok) {
            Swal.fire({ title: "Evento salvo!", icon: "success", confirmButtonColor: "#587b7f" });
            navigate("/admin/iconografico/eventos");
        } else {
            Swal.fire({ title: "Não foi possível salvar o evento", icon: "error", confirmButtonColor: "#587b7f" });
        }
    };

    return (
        <div className="admin-page-container">
            <div className="mb-4">
                <Link to="/admin/iconografico/eventos" className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar aos Eventos
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4 p-md-5">
                    <div className="section-title-modern mb-5">
                        <div className="title-accent"></div>
                        <div>
                            <h2 className="admin-title">{state.acao} Evento</h2>
                            <p className="admin-subtitle small mb-0">Detalhamento do contexto histórico</p>
                        </div>
                    </div>

                    <Form>
                        <div className="form-section-header mb-4">
                            <FontAwesomeIcon icon={faInfoCircle} className="me-2 text-teal" />
                            <span>Informações Gerais</span>
                        </div>
                        <div className="row g-4 mb-5">
                            <Form.Group className="col-md-8">
                                <Form.Label className="label-admin">* Nome do Evento</Form.Label>
                                <Form.Control 
                                    className="input-moderno" 
                                    value={state.dados.nome_evento} 
                                    onChange={e => setState({...state, dados: {...state.dados, nome_evento: e.target.value}})}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>
                            <Form.Group className="col-md-4">
                                <Form.Label className="label-admin">Tipo de Evento</Form.Label>
                                <Form.Select 
                                    className="input-moderno"
                                    value={state.dados.tipo_evento}
                                    onChange={e => setState({...state, dados: {...state.dados, tipo_evento: e.target.value}})}
                                    disabled={state.acao === "Visualizar"}
                                >
                                    <option value="">Selecionar...</option>
                                    <option value="Cerimônia">Cerimônia</option>
                                    <option value="Congresso">Congresso</option>
                                    <option value="Aula">Aula</option>
                                    <option value="Visita">Visita</option>
                                    <option value="Outro">Outro</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="col-12">
                                <Form.Label className="label-admin">Descrição do Contexto</Form.Label>
                                <Form.Control as="textarea" rows={3} className="input-moderno" value={state.dados.descricao} onChange={e => setState({...state, dados: {...state.dados, descricao: e.target.value}})} disabled={state.acao === "Visualizar"} />
                            </Form.Group>
                        </div>

                        <div className="form-section-header mb-4">
                            <FontAwesomeIcon icon={faCalendarAlt} className="me-2 text-teal" />
                            <span>Local e Período</span>
                        </div>
                        <div className="row g-4">
                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Local do Evento</Form.Label>
                                <Form.Control className="input-moderno" value={state.dados.local_evento} onChange={e => setState({...state, dados: {...state.dados, local_evento: e.target.value}})} disabled={state.acao === "Visualizar"} />
                            </Form.Group>
                            <Form.Group className="col-md-3">
                                <Form.Label className="label-admin">Data de Início</Form.Label>
                                <Form.Control type="date" className="input-moderno" value={state.dados.data_inicio ?? ""} onChange={e => setState({...state, dados: {...state.dados, data_inicio: e.target.value}})} disabled={state.acao === "Visualizar"} />
                            </Form.Group>
                            <Form.Group className="col-md-3">
                                <Form.Label className="label-admin">Data de Fim</Form.Label>
                                <Form.Control type="date" className="input-moderno" value={state.dados.data_fim ?? ""} onChange={e => setState({...state, dados: {...state.dados, data_fim: e.target.value}})} disabled={state.acao === "Visualizar"} />
                            </Form.Group>
                        </div>

                        {state.acao !== "Visualizar" && (
                            <div className="d-flex justify-content-end mt-5 pt-3 border-top">
                                <Button className="btn-apply-filters px-5" onClick={salvar}>
                                    <FontAwesomeIcon icon={faSave} className="me-2" /> Salvar Evento
                                </Button>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
}